import { IWatchfolderEngine } from './watchfolder/Watchfolder.model';

export const FINGERPRINT_RESOURCE_ID = 'edc7101e-8a9c-45e0-aac0-481213ec44a0';
export const FINGERPRINT_RESOURCE_LABEL = 'Fingerprint Incoming';

export const isFingerprintEngine = (
  engineId?: string | null,
  engines: IWatchfolderEngine[] = [],
) => {
  if (!engineId) return false;

  const engine = engines.find(
    candidate => candidate.id.toUpperCase() === engineId.toUpperCase(),
  );
  const identity = `${engineId} ${engine?.label ?? ''}`.toUpperCase();

  return identity.includes('FINGERPRINT');
};
